<!-- <p fxLayout="row" fxLayoutAlign="start center">
  <label fxFlex="30" fxShow fxHide.xs>{{label}}</label>
  <mat-form-field fxFlex.xs="100" fxFlex.gt-xs="50">
    <input matInput [type]="type" [placeholder]="placeholder" [readonly]="readonly" [(ngModel)]="value" name="value" [disabled]="disabled" [required]="required"> -->
    <!-- <input matInput [type]="type" [placeholder]="placeholder" [(ngModel)]="value" name="value"  [required]="required"> -->
  <!-- </mat-form-field>
</p> -->

<div class="container">
  <div class="row"> 
     <div class="col-12"  >
      <mat-form-field  >
         <input matInput [type]="type" [style]="style"   [placeholder]="placeholder" [readonly]="readonly" [(ngModel)]="value" name="value" [disabled]="disabled" [required]="required">
        <!-- <input matInput [type]="type" [placeholder]="placeholder" [(ngModel)]="value" name="value"  [required]="required"> -->
      </mat-form-field>
    </div> 
  </div>
</div>

<!-- <div class="d-flex  mb-2">
  <div class="p-2 bg-info flex-fill">{{label}}</div>
  <div class="p-2 bg-warning flex-fill">   <mat-form-field> <input matInput [type]="type" [placeholder]="placeholder" [readonly]="readonly" [(ngModel)]="value" name="value" [disabled]="disabled" [required]="required"> -->
    <!-- <input matInput [type]="type" [placeholder]="placeholder" [(ngModel)]="value" name="value"  [required]="required"> -->
  <!-- </mat-form-field></div> -->
  <!-- <div class="p-2 bg-primary">Flex item 3</div> -->
<!-- </div> -->

<!-- <p class="d-flex flex-row " >
  <label >{{label}}</label>
  <mat-form-field>
    <input matInput [type]="type" [placeholder]="placeholder" [readonly]="readonly" [(ngModel)]="value" name="value" [disabled]="disabled" [required]="required"> -->
    <!-- <input matInput [type]="type" [placeholder]="placeholder" [(ngModel)]="value" name="value"  [required]="required"> -->
  <!-- </mat-form-field>
</p> -->
<!-- <p fxLayout="row" fxLayoutAlign="start center">
  <label fxFlex="30" fxShow fxHide.xs>{{label}}</label>
  <mat-form-field fxFlex.xs="100" fxFlex.gt-xs="50">
    <input matInput [type]="type" [placeholder]="placeholder" [formControl]="value" [disabled]="disabled">
  </mat-form-field>
</p> -->


